import { render, staticRenderFns } from "./ModalBanner.vue?vue&type=template&id=508a7815&lang=pug&"
import script from "./ModalBanner.vue?vue&type=script&lang=js&"
export * from "./ModalBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports